import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import ContentWrapper from "src/styles/ContentWrapper"
import links from "src/links"

const FlexContentWrapper = styled(ContentWrapper)`
  display: flex;
  margin: 0;
`

const { navLinks } = links

const StyledNav = styled.nav`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 62.5rem;
    background: ${({ theme }) => theme.colors.background};
    a {
      color: ${({ theme }) => theme.colors.primary};
      margin-left: 20px;
    }
  }
  .nav-link {
    font-size: 1rem;
    font-weight: 700;
    text-align: center;
    position: relative;
    margin: 0 0 0 1.25rem;
    padding: 0;
    &::before {
      transition: 200ms ease-out;
      height: 0.1563rem;
      content: "";
      position: absolute;
      background-color: ${({ theme }) => theme.colors.primary};
      width: 0%;
      bottom: -0.125rem;
    }
    &:hover::before {
      width: 100%;
    }
  }
  .cta-btn {
    width: auto;
    height: auto;
    font-weight: 700;
    border-radius: ${({ theme }) => theme.borderRadius};
    border: 0.125rem solid ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.background};
    transition: 20ms ease-out;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    margin: 0;
    &:hover {
      background: ${({ theme }) => theme.colors.primary};
      color: #ffffff;
    }
  }
`

const Navbar = () => {
  const { menu, button } = navLinks
  return (
    <StyledNav>
      {menu.map(({ name, url }, key) => {
        return (
          <FlexContentWrapper key={key}>
            <Link className="nav-link" to={url}>
              {name}
            </Link>
          </FlexContentWrapper>
        )
      })}
      <FlexContentWrapper>
        <Link className="cta-btn" to={button.url}>
          {button.name}
        </Link>
      </FlexContentWrapper>
    </StyledNav>
  )
}

export default Navbar
